const Backbone = require('backbone');
const PurchaseView = require('app/views/store/pages/products/purchase');
const ConfigView = require('app/views/store/pages/products/config');
const HeadingView = require('app/views/store/pages/products/heading');
const UniqueIdView = require('app/views/store/pages/products/uniqueid');
const ProductHelper = require('app/views/store/common/helpers/product_helper');
const ProductModel = require('app/models/store/client/product/product');
const CartItemModel = require('app/models/store/client/cart/item');
var ProductView = Backbone.View.extend({
	el: '#configure-page',

	model: ProductModel,

	events: {
		'click .modal-trigger': '_showInformationModal',
		'change .option-value': '_handleOptionChange',
		'click .continue-configure-button': '_handleContinueClick',
		'click .continue-without-button': '_continueWithout',
		'click .change-config-link': '_changeConfig',
		'change .dont-need-this input': '_toggleAddToCartButtonText',
		'click .summary-link': '_toggleFooterSummary',
		'click .js-configure-post-to-project': 'addToAllShoppingLists'
	},
	$optionGroups: $('#option-groups'),
	$goToRecommendedOptionsButton: $('#go-to-recommended-options'),
	$selectedOptionContainer: $('.js-selected-option-container'),
	$recommendedOptions: $('#recommended-options'),
	$allDontNeedThisBoxes: $('.dont-need-this input'),

	initialize: function() {
		var self = this,
			childViewoptions = {
				parentView: self
			};

		self.model = new ProductModel(window.dataLayer);

		self.childViews.title = new HeadingView({
			model: self.model
		});
		self.childViews.uniqueid = new UniqueIdView({
			model: self.model
		});

		self.childViews.purchase = new PurchaseView(childViewoptions);
		self.childViews.config = new ConfigView(childViewoptions);
		self.listenTo(Backbone, 'product:configurePricedOptions', self.configureProduct, self);

		window.matchMedia('(orientation:landscape)').addListener(function(event) {
			self.handleOrientationChange(event.matches);
		});

		$(window).on('orientationchange', function(event) {
			self.handleOrientationChange(event.originalEvent.orientation === 'landscape');
		});

		if (this._shouldEnableRecsTransitionButton.call(this)) {
			this._enableRecsTransitionButton.call(this);
		}

		var $allPreconfiguredOptions = $('.option-group')
			.find('input, select')
			.filter(function() {
				var $this = $(this);

				if ($this.is('input')) {
					return $(this).prop('checked');
				} else if ($this.is('select')) {
					return $(this)
						.find(':selected')
						.data('value');
				}
			});

		$allPreconfiguredOptions.each(
			function(index, element) {
				this._setOptionText($(element));
			}.bind(this)
		);

		this._updateFooterSummary();

		$('#persistent-chat-prompt').addClass('with-compare-widget');
	},

	_setMultiSelectText: function($currentGroup) {
		var activeOptions = $currentGroup
			.find('.option-value')
			.filter(function() {
				return this.checked;
			})
			.map(function() {
				return `<li>${$(this).data('value')}</li>`;
			})
			.get();

		$currentGroup.find('.config-item-summary .selected-value').html(`<ul>${activeOptions.join('')}</ul>`);
	},

	_setOptionText: function($currentInput) {
		var $currentGroup = $currentInput.closest('.option-group'),
			selectedValueText = $currentInput.is('select') ? $currentInput.find(':selected').data('value') : $currentInput.data('value');

		$currentGroup.find('.config-item-summary .selected-value').text(selectedValueText);
	},

	_unSetOptionText: function($currentGroup) {
		$currentGroup.find('.config-item-summary .selected-value').text('Not Needed');
	},

	_hideOptionConfiguration: function($currentGroup) {
		$currentGroup.removeClass('pending').addClass('hide-configuration');
		$currentGroup.find('.config-item-summary').removeClass('hidden');
	},

	_shouldEnableMultiSelectContinueButton: function($currentGroup) {
		return $currentGroup.find('input').filter(':checked').length;
	},

	_enableMultiSelectContinueButton: function($currentGroup) {
		$currentGroup.find('.continue-configure-button').prop('disabled', false);
	},

	_shouldEnableRecsTransitionButton: function() {
		var $allOptionGroups = $('.option-group');

		if ($allOptionGroups.length === 1) {
			$allOptionGroups
				.find('.continue-configure-button')
				.addClass('hidden')
				.prop('disabled', true);
			return true;
		} else {
			return $allOptionGroups.length === $allOptionGroups.filter('.multiSelect').length
				? true
				: !this.$optionGroups.find('.pending').length;
		}
	},

	_enableRecsTransitionButton: function() {
		this.$goToRecommendedOptionsButton.removeClass('disabled');
	},

	_filterSelectedOptionGroups: function(index, currentGroup) {
		var $currentGroup = $(currentGroup),
			isSelect = $currentGroup.find('select').length;

		return isSelect ? $currentGroup.find('select').val() : $currentGroup.find('input:checked').length;
	},

	_formatActiveInputData: function(index, currentInput) {
		var $currentInput = $(currentInput),
			groupTitle = $currentInput
				.closest('.option-group')
				.find('.config-title')
				.text(),
			groupValue = $currentInput.data('value'),
			groupPrice = $currentInput.data('price-text');

		return {
			groupTitle: groupTitle,
			groupValue: groupValue,
			groupPrice: groupPrice
		};
	},

	_formatGroupSummaryData: function(index, currentGroup) {
		var $currentGroup = $(currentGroup),
			isSelect = $currentGroup.find('select').length,
			$activeInputs = isSelect ? $currentGroup.find('select :selected') : $currentGroup.find('input:checked'),
			/*
			 * Running $.fn.get against a collection that's been passed through $.fn.map gives you a basic array.
			 * Check http://api.jquery.com/map/ -> "As the return value is a jQuery object, which contains an array, it's very common to call .get() on the result to work with a basic array".
			 */
			activeInputData = $activeInputs.map(this._formatActiveInputData).get();

		return activeInputData;
	},

	_flattenSummaryArray: function(previous, current) {
		return previous.concat(current);
	},

	// Instead of doing something fancy here with state management, I'm going to brute-force it.
	_updateFooterSummary: function() {
		var selectedOptionGroups = this.$optionGroups.find('.option-group').filter(this._filterSelectedOptionGroups),
			configuredOptionsList = selectedOptionGroups
				.map(this._formatGroupSummaryData.bind(this))
				.get()
				.reduce(this._flattenSummaryArray, []);

		if (configuredOptionsList.length) {
			$('.js-customized-list').removeClass('hidden');

			this.$selectedOptionContainer.html(
				configuredOptionsList
					.map(({ groupTitle, groupValue, groupPrice }) => {
						return `<li><b>${groupTitle}</b>: ${groupValue} - <span class="text-green">${groupPrice}</span></li>`;
					})
					.join('')
			);
		}
	},

	_jumpToNextOptionGroup: function($currentGroup) {
		var currentGroupIndex = $currentGroup.index(),
			$totalOptionGroups = $('.js-all-available-options').find('.option-group');

		if (currentGroupIndex + 1 !== $totalOptionGroups.length) {
			$('.html, body').animate(
				{
					scrollTop: $totalOptionGroups.eq(currentGroupIndex + 1).offset().top
				},
				300
			);
		}
	},

	_handleOptionChange: function(e) {
		var $currentInput = $(e.currentTarget),
			$currentGroup = $currentInput.closest('.option-group');

		if ($currentGroup.data('optionIdentity') !== 'FreeKeyingOption' && !$currentGroup.hasClass('multiSelect')) {
			this._hideOptionConfiguration($currentGroup);
		}

		if (this._shouldEnableRecsTransitionButton.call(this)) {
			this._enableRecsTransitionButton.call(this);
		}

		if ($currentGroup.is('.multiSelect') && this._shouldEnableMultiSelectContinueButton($currentGroup)) {
			this._enableMultiSelectContinueButton($currentGroup);
		}

		if ($currentGroup.hasClass('multiSelect')) {
			this._setMultiSelectText($currentGroup);
		} else {
			this._setOptionText($currentInput);
		}

		this._updateFooterSummary.call(this);
	},

	_unsetOptionGroup: function($currentGroup) {
		$currentGroup.find('.option-value').each(
			function(index, currentInput) {
				var $currentInput = $(currentInput);

				if ($currentInput.is('[type="checkbox"]')) {
					$currentInput.prop('checked', false);
					$currentInput.parent('label').removeClass('selected');
				} else if ($currentInput.is('[type="radio"]')) {
					$currentInput.prop('checked', false);
				} else {
					$currentInput.val('');
				}

				this._unSetOptionText($currentGroup);

				this._updateFooterSummary();
			}.bind(this)
		);
	},

	_handleContinueClick: function(e) {
		e.preventDefault();

		if (window.BCOM.data.isPla) {
			this.childViews.purchase.childViews.addToCart.transitionConfigSteps(e);
		}

		var $currentGroup = $(e.currentTarget).closest('.option-group');

		this._hideOptionConfiguration($currentGroup);

		this._jumpToNextOptionGroup.call(this, $currentGroup);

		if (this._shouldEnableRecsTransitionButton.call(this)) {
			this._enableRecsTransitionButton.call(this);
		}
	},

	_continueWithout: function(e) {
		var $currentGroup = $(e.target).closest('.option-group');

		e.preventDefault();

		$currentGroup.find('.continue-configure-button').prop('disabled', true);

		this._hideOptionConfiguration($currentGroup);
		this._unsetOptionGroup($currentGroup);
	},

	_changeConfig: function(e) {
		e.preventDefault();

		var $currentGroup = $(e.currentTarget).closest('.option-group');

		$currentGroup.removeClass('hide-configuration');
		$currentGroup.find('.config-item-summary').addClass('hidden');
	},

	updateRecommendedOptionQuantities: function(quantityInfo) {
		var quantity;

		if (this.model.hasPricingByUOM()) {
			quantity = this.model.getQuantityForSquareFootage(quantityInfo.quantity);
		} else {
			quantity = quantityInfo.quantity;
		}

		if (quantityInfo.id === 'main-product-quantity') {
			this.model.recommendedOptions.each(function(option) {
				option.set('quantity', quantity);
			});
			this.childViews.recommendedOptions.forEach((optionView) => {
				optionView.matchOptionQuantityToProductQuantity();
			});
		}
	},

	handleOrientationChange: function(isLandscape) {
		if (isLandscape && this.selectedTabHash === '#product-spec-target') {
			this.$('#product-tabs li:first a').trigger('click');
		}
	},

	_notifyClosedModal: function() {
		Backbone.trigger('modal:close');
	},

	_toggleFooterSummary: function(e) {
		$(e.target)
			.parents('.modal-add-to-cart')
			.toggleClass('collapsed');
		$('body').toggleClass('no-scroll');
	},

	_formatLabel: function(label) {
		return label.replace(/([A-Z])/g, ' $1');
	},

	_showInformationModal: function(e) {
		var $modal = $('.js-modal-configureInformation'),
			modalTitle = 'More Info',
			modalContent = $(e.target)
				.closest('.selected-manufacturer-container')
				.find('.js-product-summary')
				.html();

		e.preventDefault();

		$modal.find('.modal-title').html(modalTitle);
		$modal.find('.modal-body').html(modalContent);
		$modal.modal();
	},

	_toggleAddToCartButtonText: function() {
		var checkedBoxes = this.$allDontNeedThisBoxes.filter(function() {
			return this.checked;
		}).length;

		if (checkedBoxes) {
			$('.js-add-to-cart').text('Add to Cart');
		} else {
			$('.js-add-to-cart').text('Add All to Cart');
		}
	},
	addToAllShoppingLists: function() {
		if (
			this.model.recommendedOptions &&
			this.model.recommendedOptions.models &&
			this.model.recommendedOptions.models.every((option) => option.get('isNeeded') === false)
		) {
			Backbone.trigger('omniture:projects', 'complex_products', 'no_thanks');
			return this.addAllSuccessCallback();
		}
		Backbone.trigger('omniture:projects', 'complex_products', 'save');
		if (window.BCOM.util.getQueryStringParameter('isProjectsQuickAdd')) {
			return this.saveItemToShoppingList().then(() => this.addAllSuccessCallback());
		}
		const allListIDs = window.dataLayer.shoppingListIDs,
			savingToLists = allListIDs.map((currentListID) => this.saveItemToShoppingList.call(this, currentListID));

		Promise.all(savingToLists).then(() => {
			this.setupNotification();
			this.addAllSuccessCallback();
		});
	},
	saveItemToShoppingList: function(sessionCartId) {
		const cartItemModel = new CartItemModel(
			Object.assign(ProductHelper.getDefaultCartItemModelConfig(this.model, window.dataLayer.hasRecommendedOption), {
				sessionCartId,
				isProjectsQuickAdd: window.BCOM.util.getQueryStringParameter('isProjectsQuickAdd')
			})
		);
		if (this.showQuantitySelector) {
			cartItemModel.set({ quantity: parseInt(this.$quantityInput.val(), 10) });
		}
		return cartItemModel.save();
	},
	addAllSuccessCallback: function() {
		if (window.BCOM.util.getQueryStringParameter('isProjectsQuickAdd')) {
			const redirect = JSON.parse(window.localStorage.getItem('projectsQuickAddSource')).url;
			window.location.assign(redirect);
			return;
		}
		const allShoppingListsIDs = window.BCOM.util.getQueryStringParameter('shoppingListIDs');
		let redirectURL = `${
			window.location.href.split('configure')[0]
		}?showProjectConfirmation=true&uid=${window.BCOM.util.getQueryStringParameter('uid')}`;

		if (allShoppingListsIDs.split(',').length === 1) {
			redirectURL = `${redirectURL}&savedShoppingListID=${allShoppingListsIDs}`;
		}
		window.location.assign(redirectURL);
	},
	setupNotification: function() {
		const param = window.BCOM.util.getQueryStringParameter('project');
		if (!param) {
			return;
		}
		const [name, id] = param.split(':');
		const notification = `
			<div class="w-100">
				<p class="b mb0">Saved to ${name}!</p>
				<a href="/account/projects/${id}/feed" class="pl1 underline theme-success pointer">Go to Project</a>
			</div>
		`;
		localStorage.setItem('reqRecNotification', notification);
		window.BCOM.notifications.render(notification, 'success');
	}
});

module.exports = ProductView;
